var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Propriétés d'un intervalle")]),_c('iframe',{attrs:{"src":"static/frames/proprietes/index.html","width":"620","height":"720","frameborder":"0","scrolling":"no"}})])
}]

export { render, staticRenderFns }